import React from 'react'
import PpmPlannerMain from '../../components/ppmplanner/ppmPlannerMain'
function PpmPlanner() {
    return (
        <>

            {/*Dynamic content goes here */}
            <PpmPlannerMain />

        </>
    )
}

export default PpmPlanner